import { Button } from "@mui/material";
import { ICardEventAdmin } from "../../../models/component/ICardEventAdmin";

const CardEventAdmin = ({ images, name, description, date, onDelete }: ICardEventAdmin & { onDelete: (id: string) => void; }) => {

  const handleDeleteEvent = () => {
    onDelete(name);
  };

  return (
    <div className="component-card-event-admin">
      <div className="left-part">
        {images && images.length > 0 ? (
          images.map((image, index) => (
            <img key={index} src={`https://api.leblr.fr${image.uri}`} alt={`${name} image ${index + 1}`}  />
          ))
        ) : (
          <p>Aucune image disponible</p> // Message en cas d'absence d'images
        )}
      </div>
      <div className="right-part">
        <div className="title">{name}</div>
        <div className="subtitle">{description}</div>
        <div className="subtitle">{date}</div>
      </div>
      <div className="right-part-content-element-event">
        <Button
          variant="contained"
          onClick={handleDeleteEvent}
          sx={{ background: "rgb(255,255, 255)", fontSize: 30 }}
        >
          <img style={{ width: 20, height: 20 }} src="/assets/icons/delete.png" alt="Delete" />
        </Button>
      </div>
    </div>
  );
}

export default CardEventAdmin;
